/**
 * Compact identity chip + sign-out for the dashboard header. Shows who you are
 * (the SSO-resolved Auth0 user) and lets you log out through Auth0.
 */
import { useAuth } from "@/lib/auth/useAuth";

export function UserMenu() {
  const { user, logout } = useAuth();
  if (!user) return null;

  const label = user.name || user.email || user.sub;
  const initial = (label || "?").charAt(0).toUpperCase();

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2 rounded-full border border-fg-faint/20 bg-fg-faint/5 px-2 py-1">
        {user.picture ? (
          <img
            src={user.picture}
            alt=""
            className="h-5 w-5 rounded-full object-cover"
            referrerPolicy="no-referrer"
          />
        ) : (
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-info-text/15 text-[10px] font-semibold text-info-text">
            {initial}
          </span>
        )}
        <span className="max-w-[12rem] truncate text-xs text-fg-muted" title={label}>
          {label}
        </span>
      </div>
      <button
        type="button"
        onClick={logout}
        className="rounded-md border border-fg-faint/20 px-2 py-1 text-xs text-fg-faint transition-colors hover:text-fg-primary"
      >
        Sign out
      </button>
    </div>
  );
}
